(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["weboost_collection_faq"] && !window.DesignMode) return;
  try {
    
  (function() {
   function escapeHtml(text) {
     return text.replace(/"/g, '\\"').replace(/\n/g, ' ').replace(/\s+/g, ' ').trim();
   }
   var faqContainer = document.querySelector('#faq-section .faq-container');
   if (faqContainer) {
     var items = [];
     var faqs = faqContainer.querySelectorAll('.faq-item');
     faqs.forEach(function(faq) {
       var q = faq.querySelector('.faq-question');
       var a = faq.querySelector('.faq-answer');
       if (q && a) {
         items.push({
           "@type": "Question",
           "name": escapeHtml(q.textContent),
           "acceptedAnswer": {
             "@type": "Answer",
             "text": escapeHtml(a.innerHTML)
           }
         });
       }
     });
     if (items.length > 0) {
       var ld = {
         "@context": "https://schema.org",
         "@type": "FAQPage",
         "mainEntity": items
       };
       var script = document.createElement('script');
       script.type = 'application/ld+json';
       script.text = JSON.stringify(ld);
       document.body.appendChild(script);
     }
   }
 })();

  } catch(e) { console.error(e); }
})();
})();
